import React from 'react';
import { Button, Typography } from 'fronton-react';
import { errorContainer, errorTitle } from './old-styles';

type ErrorProps = { fetchSuggestions: () => void };

export const Error: React.FC<ErrorProps> = ({ fetchSuggestions }) => (
  <div className={errorContainer} data-qa-header-search-error="">
    <Typography className={errorTitle} variant="s" size="body_short" data-qa-header-search-error-title="">
      При отправке запроса произошла ошибка <br /> Попробуйте еще раз.
    </Typography>

    <Button
      kind="regular"
      variant="primary"
      size="s"
      onClick={fetchSuggestions}
      data-qa-header-search-error-retry="">
      Повторить
    </Button>
  </div>
);
